import React, { memo, useEffect } from "react";
import { useDispatch } from "react-redux";
import useMulticotizadorSelector from "./useMulticotizadorSelector";
import { OpcionSeleccionada } from "../types";
import VehiculoModeloSelector from "~business/vehiculoModeloSelector/vehiculoModeloSelector";
import { makeStyles } from "@mui/styles";
import { setVehiculoModelo, clearVehiculoModelo } from "../actions";
import MulticotizadorContent from "./MulticotizadorContent";
import PrimaryTitle from "~styled/primaryTitle/PrimaryTitle";

const useStyles = makeStyles((theme) => ({
  title: {
    paddingBottom: "16px",
  },
}));

const useReduxSelector = () =>
  useMulticotizadorSelector((state) => ({
    modeloSelected: state.modeloSelected,
    marcaSelected: state.marcaSelected,
    anioSelected: state.anioSelected,
  }));

const ModeloStep = memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { modeloSelected, marcaSelected, anioSelected } = useReduxSelector();

  const handleChange = (event: { target: { value: OpcionSeleccionada } }) => {
    dispatch(setVehiculoModelo(event.target.value));
  };

  useEffect(() => {
    dispatch(clearVehiculoModelo());
  }, [dispatch]);

  return (
    <>
      <MulticotizadorContent>
        <div className={classes.title}>
          <PrimaryTitle
            label="Ingresá el Modelo del vehículo del asegurado"
            marginBottom={32}
          />
        </div>
        <VehiculoModeloSelector
          value={modeloSelected}
          marca={marcaSelected}
          anio={anioSelected}
          onChange={handleChange}
        />
      </MulticotizadorContent>
    </>
  );
});

export default ModeloStep;
